import React from 'react'
import { useTranslation } from 'react-i18next'

const useCustomT = (tPrefix: string) => {
   const { t: translation } = useTranslation()
   const t = (key: string, arg = {}) => translation(`${tPrefix}.${key}`, arg)

   return t
}

export { useCustomT }
